export default __webpack_public_path__ + "static/media/KhangchungTso.a438c579.webp";